export enum AuthRole {
  ADMIN = 'admin',
  EMPLOYER = 'employer',
  JOBSEEKER = 'jobseeker',
  SELF = 'self',
}

export enum AuthOTPType {
  PASSWORD_RESET = 'password-reset',
  EMAIL_VERIFICATION = 'email-verification',
  EXTERNAL_OTP = 'external-otp',
}
